<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeTutorStatus
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeTutorStatusProps } from '../types/interfaces'

import { useBadgeTutorStatus } from '../composables/use-badge-tutor-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeTutorStatus',
})

const props = defineProps<BadgeTutorStatusProps>()

const {
  color,
  text,
  visible,
} = useBadgeTutorStatus({ props })
</script>

<template>
  <AppBadge
    v-if="visible"
    :color="color"
    :text="text"
  />
</template>
